<template>
  <div>
    <CCard>
      <CCardHeader> <CIcon name="cil-grid" />Tambah Brand </CCardHeader>
      <CCardBody>
        <div class="form-group">
          <label>Nama</label>
          <input type="text" class="form-control" v-model="data.name" />
        </div>
      </CCardBody>
      <CCardFooter>
        <btn-save-update
          :data="data"
          @save="saveBrand"
          @update="updateBrand"
          @back="goBack"
          :loading="saving"
        />
      </CCardFooter>
    </CCard>
  </div>
</template>
<script>
import BtnSaveUpdate from "../../components/BtnSaveUpdate";
import { getErrorMessage } from "../../lib/helpers";
import { HTTPAUTH } from "../../lib/httplib";
export default {
  components: {
    BtnSaveUpdate,
  },
  data() {
    return {
      data: {},
      saving: false,
    };
  },
  created() {
    var id = "";
    const route = this.$route;
    if (route.params && route.params.id) {
      id = route.params.id;
    } else {
      location.href = "#/product/brand";
      return;
    }
    this.get(id);
  },
  methods: {
    get(id) {
      HTTPAUTH.get(`/api/admin/brand/${id}`).then((res) => {
        this.data = res.data.data;
      });
    },
    saveBrand() {
      this.saving = true;
      HTTPAUTH.post(`/api/admin/brand`, this.data)
        .then((res) => {
          this.$toasted.success("Data berhasil ditambahkan").goAway();
          this.data = res.data.data;
          this.get(this.data.slug);
          this.saving = false;
        })
        .catch((eres) => {
          this.$toasted.error(getErrorMessage(eres)).goAway();
          this.saving = false;
        });
    },
    updateBrand() {
      this.saving = true;
      HTTPAUTH.put(`/api/admin/brand/${this.data.id}`, this.data)
        .then((res) => {
          this.$toasted.success("Data berhasil ditambahkan").goAway();
          this.get(this.data.slug);
          this.saving = false;
        })
        .catch((eres) => {
          this.$toasted.error(getErrorMessage(eres)).goAway();
          this.saving = false;
        });
    },
    goBack() {
      this.$router.push({ path: "/product/brand" });
    },
  },
};
</script>